import * as React from 'react';

interface UploadSimpleFileProps {
    fileSelected: (file: File) => Promise<void>;
    acceptedUploadFileTypes: string[];
    localizedUploadButtonText: string;
    hide?: boolean; // default is false
    buttonId?: string;
}

export default class SelectFileForUpload extends React.PureComponent<UploadSimpleFileProps> {

    // ===============================================================================

    public render() {
        return (
            <React.Fragment>
                <button id={this.props.buttonId ? this.props.buttonId : ""} className="btn btn-default" style={this.props.hide ? { display: 'none' } : {}} onClick={this.uploadButton_click}>{this.props.localizedUploadButtonText}</button>
                <input type="file" accept={this.props.acceptedUploadFileTypes.join(", ")} id="upload-file-input" style={{ display: 'none' }} onChange={this.uploadFileInput_onChange} />
            </React.Fragment>
        );
    }

    // ===============================================================================
    //
    // UI Events
    //

    private uploadButton_click = (e: React.MouseEvent) => {
        $('#upload-file-input').click();
    }

    // ===============================================================================

    private uploadFileInput_onChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if ((e.target.files === null) || (e.target.files.length === 0)) {
            return;
        }

        const file = e.target.files[0];

        // Clear the file so another import is possible.
        e.target.value = '';

        await this.props.fileSelected(file);
    }
}